export class AlunoSae {
    public id: number;
    public nome: string;
    public email: string;
    public sexo: string;
    public dataNascimento: Date;
    public nomePai: string;
    public nomeMae: string;
    public alunoBloqueado: boolean;
    public dataIngresso: number;
    public dataSaida: number;
    public registroAcademico: string;
    public telefone: string;
    public celular: string;
    public endereco: string;
    public cidade: string;
    public uf: string;


}
